module.exports = __webpack_public_path__ + "fonts/boxicons.87806131.ttf";